import { DateTime } from 'luxon';

import { generateUUID } from '@/globals';

export interface IAdServerPlayApi {
  played_time_utc: string;
  creativefile_id: number;
  creativefile_url: string;
  unit_id: number;
  latitude: number;
  longitude: number;
}

export default class AdServerPlay {
  playedOnUtc: DateTime;

  creativeFileID: number;

  creativeFileUrl: string;

  unitID: number;

  latitude: number;

  longitude: number;

  id: string;

  constructor(
    playedOnUtc: DateTime,
    creativeFileID: number,
    creativeFileUrl: string,
    unitID: number,
    latitude: number,
    longitude: number,
    addFuziness = false,
  ) {
    this.playedOnUtc = playedOnUtc;
    this.creativeFileID = creativeFileID;
    this.creativeFileUrl = creativeFileUrl;
    this.unitID = unitID;
    this.latitude = latitude;
    this.longitude = longitude;
    this.id = `${generateUUID()}-${Math.random()}`;

    if (addFuziness) {
      this.addFuzinessToTime();
    }
  }

  get creativeFileThumbnailUrl() {
    const file =
      this.creativeFileUrl.indexOf('.jpg') > -1 || this.creativeFileUrl.indexOf('.png') > -1
        ? 'thumbnail.0000000.jpg'
        : 'thumbnail.0000002.jpg';

    return `${this.creativeFileUrl.substr(0, this.creativeFileUrl.lastIndexOf('.'))}-${file}`;
  }

  addFuzinessToTime(): void {
    this.playedOnUtc = this.playedOnUtc.plus({ milliseconds: Math.random() * 1000 });
  }

  static fromApi(apiObject: IAdServerPlayApi): AdServerPlay {
    return new AdServerPlay(
      DateTime.fromISO(apiObject.played_time_utc, { zone: 'utc' }),
      apiObject.creativefile_id,
      apiObject.creativefile_url,
      apiObject.unit_id,
      apiObject.latitude,
      apiObject.longitude,
      false,
    );
  }
}
